import { useChallenges } from '../../../redux/reducer/content';
import useGetFullAchievementsList from './useGetFullAchievementsList';

export default function useFindAchievementById() {
  const getFullAchievementsList = useGetFullAchievementsList();
  const { icons } = useChallenges();

  return (id, iconsList = icons) => {
    return getFullAchievementsList(iconsList).find(({ id: iconId }) => iconId === id);
  };
}
